import { toast } from "react-toastify";
import { getStore } from "../storeRef";
import { showErrorDialog } from "../slices/errorDialogSlice";
import { showAccessDenied } from "../slices/accessDeniedSlice";
import { setAuthError } from "../slices/authSlice";

const unwrapBlobErrorData = async (error) => {
  const data = error.response?.data;
  if (!(data instanceof Blob)) {
    return;
  }

  try {
    const text = await data.text();
    error.response.data = JSON.parse(text);
  } catch {
  }
};

export const handleApiError = async (error) => {
  await unwrapBlobErrorData(error);

  if (error.config?.suppressErrorToast) {
    return;
  }

  const store = getStore();
  const status = error.response?.status;
  const data = error.response?.data;

  const getMessage = () => {
    return data?.message ||
      data?.userMessage ||
      data?.errorMessage ||
      data?.error ||
      'An error occurred';
  };

  switch (status) {
    case 404:
      toast.warn(getMessage());
      break;

    case 400:
      toast.error(getMessage());
      break;

    case 460:
      toast.error(getMessage());
      break;

    case 463:
      store?.dispatch(showErrorDialog(getMessage()));
      break;

    case 464:
      break;

    case 403:
      store?.dispatch(showAccessDenied(getMessage()));
      break;

    case 401:
      store?.dispatch(setAuthError());
      break;

    case 500:
    default:
      if (status >= 500) {
        toast.error('An unexpected error occurred');
      }
      break;
  }
};
